export default __webpack_public_path__ + "static/media/social.084c9ae7.png";